import { render, staticRenderFns } from "./phdThesis.vue?vue&type=template&id=51facd9a&"
import script from "./phdThesis.vue?vue&type=script&lang=js&"
export * from "./phdThesis.vue?vue&type=script&lang=js&"
import style0 from "./phdThesis.vue?vue&type=style&index=0&id=51facd9a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports